import React, { useEffect, useState } from "react";
import { Button, Card, Col, Container, FloatingLabel, Form, FormControl, Row } from "react-bootstrap";
import { useAuthState } from "../../context/AuthContext";
import PrivateApi from "../../services/PrivateApiService";
import HoverCard from "../../components/shared/HoverCard";
import { MdError, MdOutlineQrCode2 } from "react-icons/md";
import { TbConfetti, TbWriting } from "react-icons/tb";
import QrScannerComponent from "../../components/shared/QrScannerComponent";
import SelectAnlageCard from "../../components/anlage/SelectAnlageCard";
import AnlageDataStage from "../../components/anlage/new_anlage/AnlageDataStage";
import Validator from "../../services/Validator";
import { FaCheck, FaLocationDot, FaXmark } from "react-icons/fa6";
import { BsDeviceSsdFill } from "react-icons/bs"
import RegisterAnlageSmallCard from "../../components/anlage/RegisterAnlageSmallCard";
import CommonUtils from "../../utils/common";

const AnmeldenPage = () => {

    // initial vars
    const { user } = useAuthState();
    const API = new PrivateApi();
    const VALIDATOR = new Validator();
    const UTILS = new CommonUtils();

    const [stage, setStage] = useState({
        choice: { inView: true, done: true },
        scanQr: { inView: false, done: false },
        address: { inView: false, done: false },
        anlageData: {inView: false, done: false},
        registerData: {inView: false, done: false},
        summary: { inView: false, done: false},
        done: { inView: false, done: false },
    });
    const [data, setData] = useState({
        choice: "manual",
        qr_code: "",

        anlagenUse: "Wohnung",
        anlagenUseDesc: "",
        street: "",
        houseNr: "",
        stiege: "",
        top: "",
        zip: "",
        city: "",

        energyForm: "",
        smartmeter: false,
        zaehlerNumber1: "",
        zaehlerNumber2: "",
        zaehlerLocation: "",
        smartmeter2: false,
        secondZaehler: false,

        register: true,
        registerDate: "",
        zaehlerstand1: "",
        zaehlerstand2: "",

        anlagen: [],
    });
    const [errors, setErrors] = useState({});

    // qr code
    const [isScaned, setIsScaned] = useState(false);
    const [qrCode, setQrCode] = useState("");
    const [qrData, setQrData] = useState(null);
    const [qrScanError, setQrScanError] = useState("");

    
    // * Effects

    // qr effect 
    useEffect(() => {
        if (qrCode !== "") {
            var qr = qrCode.split("/qr/")[1];
            if (qr && qr !== "") {
                API.private_qr_scanned(qr)
                    .then(res => {
                        setQrData(res.data);
                        setIsScaned(true)
                        setQrCode(qr);

                        var qrAnlagen = [];

                        if (res.data.anlagen.length > 0) {
                            qrAnlagen = res.data.anlagen.map(obj => ({
                                ...obj,
                                register: true,
                                registerDate: "",
                                x_zaehlerstand_01: "",
                                x_zaehlerstand_02: "",
                            }));
                        }

                        setQrData(prev => ({...prev,
                            anlagen: qrAnlagen
                        }));

                        setData(prev => ({...prev, 
                            qr_code: qr,
                            anlagen: qrAnlagen,
                            top: res.data.top,
                        }));
                    })
                    .catch(err => {
                        console.error(err);
                    });
            }
        }
    }, [qrCode])


    // * Handlers

    // handler for anlagen from qr select/deselect
    const qrSelectAnlageHandler = (anlage) => {
        setErrors({});
        if (data.anlagen.some(a => a.id === anlage.id)) {
            setData(prev => ({
                ...prev, 
                anlagen: prev.anlagen.filter(item => item.id !== anlage.id)
            }));
        }
        else {
            setData(prev => ({
                ...prev, 
                anlagen: [...prev.anlagen, anlage]}));
        }
    }


    // send data to server
    const send_data = () => {
        data.user = user;
        data.qr_code = qrCode;

        API.private_Anlagen_new(data)
            .then(() => {
                return setStage(prev => ({...prev,
                    summary: ({...prev.summary, inView: false}),
                    done: ({...prev.done, inView: true})
                }));
            });
    }

    // next btn handler
    const nextBtnHandler = () => {
        var err = {}; // temp errors

        // check for errors
        if (stage.choice.inView) {
            if (data.choice === "") err.choice = true;
        }
        if (stage.scanQr.inView) {
            if (data.anlagen.length === 0) {
                err.anlagen = "Es muss mindestens eine Anlage ausgewählt sein.";
            }
        }
        if (stage.address.inView) {
            if (data.anlagenUse === "Andere" && data.anlagenUseDesc === "")  err.anlageUseDesc = true;
            if (data.street === "" || data.street.length < 4) err.street = true;
            if (data.houseNr === "") err.houseNr = true;
            if ((data.zip.length < 4 && data.zip.length > 5 )|| !VALIDATOR.IsNumeric(data.zip)) err.zip = true;
            if (data.city === "" || data.city.length < 4) err.city = true;
        }
        if (stage.anlageData.inView) {
            if (data.energyForm === "") err.energyForm = true;
            if (data.zaehlerNumber1 === "" || data.zaehlerNumber1.length < 4) err.zaehlerNumber1 = true;
            if (data.secondZaehler && data.zaehlerNumber2.length < 4) err.zaehlerNumber2 = true;
        }
        if (stage.registerData.inView) {
            if (data.anlagen.length > 0) {
                data.anlagen.map(a => {
                    if (a.register === true && VALIDATOR.dateValid(a.registerDate) === false) {err.registerDate={}; err.registerDate[a.id] = true;}
                    if (a.register === true && VALIDATOR.IsZaehlerstand(a.x_zaehlerstand_01) === false) {err.x_zaehlerstand_01={}; err.x_zaehlerstand_01[a.id] = true;}
                    if (a.register === true && a.x_zaehlernummer_02 !== "" && VALIDATOR.IsZaehlerstand(a.x_zaehlerstand_02) === false) {err.x_zaehlerstand_02={}; err.x_zaehlerstand_02[a.id] = true;}
                });
            } else {
                if (data.register === true) {
                    if (VALIDATOR.dateValid(data.registerDate) === false) err.registerDate = true;
                    if (data.smartmeter === false && VALIDATOR.IsZaehlerstand(data.zaehlerstand1) === false) err.zaehlerstand1 = true;
                    if (data.smartmeter === false && data.secondZaehler === true && VALIDATOR.IsZaehlerstand(data.zaehlerstand2) === false) err.zaehlerstand2 = true;
                }
            }
        }

        // if there are errors return it
        if (Object.keys(err).length > 0) {
            return setErrors(err);
        }

        if (stage.scanQr.inView === true) {
            return setStage(prev => ({...prev,
                scanQr: ({...prev.scanQr, inView: false}),
                registerData: ({...prev.registerData, inView: true})
            }));
        }

        // no errors procede to next stage
        setStage((prevStage) => {
            const stageKeys = Object.keys(prevStage);
            let currentStageIndex = stageKeys.findIndex(key => prevStage[key].inView);

            if (currentStageIndex === -1 || currentStageIndex === stageKeys.length -1) {
                return prevStage;
            }
            
            const nextStageIndex = currentStageIndex + 1;
            const updateStage = {...prevStage};
            updateStage[stageKeys[currentStageIndex]].inView = false;
            
            if (stageKeys[currentStageIndex] === "choice" && data.choice === "manual") {
                updateStage[stageKeys[nextStageIndex +1]].inView = true;
            }
            else {
                updateStage[stageKeys[nextStageIndex]].inView = true;
            }
            return updateStage;
        })

    };

    const backBtnHandler = () => {
        console.log(data);
        
        if (stage.scanQr.inView && isScaned) {
            setData(prev => ({...prev,
                qr_code: "",
                anlagen: [],
                top: ""
            }));
            setQrData(null);
            setQrCode("");
        }

        if (stage.registerData.inView === true && data.anlagen.length > 0) {
            console.log(qrData.anlagen, data.anlagen);
            
            return setStage(prev => ({...prev,
                registerData: ({...prev.registerData, inView: false}),
                scanQr: ({...prev.scanQr, inView: true})
            }));
        }     
        setStage((prevStage) => {

            const stageKeys = Object.keys(prevStage);
            let currentStageIndex = stageKeys.findIndex(key => prevStage[key].inView);

            if (currentStageIndex === -1 || currentStageIndex === stageKeys.length -1) {
                return prevStage;
            }

            const previousStageIndex = currentStageIndex - 1;
            const updateStage = {...prevStage};
            updateStage[stageKeys[currentStageIndex]].inView = false;

            if (stageKeys[currentStageIndex] === "address" && data.choice === "manual") {
                updateStage[stageKeys[previousStageIndex -1]].inView = true;
            }
            else {
                updateStage[stageKeys[previousStageIndex]].inView = true;
            }
            return updateStage;
        })
    }


    const resetAll = (e) => {
        e.preventDefault();
        setData({
            choice: "manual",
            qr_code: "",
    
            anlagenUse: "Wohnung",
            anlagenUseDesc: "",
            street: "",
            houseNr: "",
            stiege: "",
            top: "",
            zip: "",
            city: "",
    
            energyForm: "",
            smartmeter: false,
            zaehlerNumber1: "",
            zaehlerNumber2: "",
            zaehlerLocation: "",
            smartmeter2: false,
            secondZaehler: false,
    
            register: true,
            registerDate: "",
            zaehlerstand1: "",
            zaehlerstand2: "",
    
            anlagen: [],
        });
        setQrData(null);
        setQrCode("");
        setStage(prev => ({...prev,
            done: ({...prev.done, inView: false}),
            choice: ({...prev.choice, inView: true})
        }));
    }


    return (
        <Container className="text-start">
            <Row>
                <Col>
                    <h3>Neue Anlage</h3>
                    <p className="text-muted">Hier können Sie neue Anlage hinzufügen</p>
                </Col>
            </Row>
            <Row className="mt-3 justify-content-center">
                <Col xl="10">
                    <Card style={{ borderRadius: 15, minHeight: 200, borderBottom: "6px solid #a2c13f" }} className="shadow-lg">
                        <Card.Body>
                            <ol className="stepper" hidden={stage.done.inView}>
                                <li className={stage.choice.inView ? "active animate_animated animate_backInRight" : "animate__animated animate__bounceOutRight"}>
                                    Auswahl
                                </li>
                                <li hidden={data.choice !== "QR"} className={stage.scanQr.inView ? "active animate__animated animate__backInRight" : "animate__animated animate__bounceOutRight"}>
                                    QR-Code scannen
                                </li>
                                <li hidden={data.choice === "QR"} className={stage.address.inView ? "active animate__animated animate__backInRight" : "animate__animated animate__bounceOutRight"}>
                                    Adresse
                                </li>
                                <li hidden={data.choice === "QR"} className={stage.anlageData.inView ? "active animate__animated animate__backInRight" : "animate__animated animate__bounceOutRight"}>
                                    Anlagendaten
                                </li>
                                <li className={stage.registerData.inView ? "active animate__animated animate__backInRight" : "animate__animated animate__bounceOutRight"}>
                                    Anmeldedaten
                                </li>
                                <li className={stage.summary.inView ? "active animate__animated animate__backInRight" : "animate__animated animate__bounceOutRight"}>
                                    Ihre Zusammenfassung
                                </li>
                            </ol>
                            <Row className="mt-3">
                                {
                                    stage.choice.inView?
                                        <>
                                            <Col xl="6">
                                                <HoverCard
                                                    color="primary"
                                                    icon={<TbWriting size={100} style={{strokeWidth: 1}} />}
                                                    desc="Daten manuell eingeben"
                                                    isSelected={data.choice === "manual"}
                                                    clickHandler={() => 
                                                        data.choice === "manual"? 
                                                            setData(prev => ({...prev, choice: ""})) :
                                                            setData(prev => ({...prev, choice: "manual"}))
                                                    }
                                                />
                                            </Col>
                                            <Col xl="6">
                                                <HoverCard
                                                    color="energo"
                                                    icon={<MdOutlineQrCode2 size={100} />}
                                                    desc="QR-Code scannen"
                                                    isSelected={data.choice === "QR"}
                                                    clickHandler={() => 
                                                        data.choice === "QR"?
                                                            setData(prev => ({...prev, choice: ""})) :
                                                            setData(prev => ({...prev, choice: "QR"}))
                                                    }
                                                />
                                            </Col>
                                        </> :
                                    
                                    stage.scanQr.inView ? 
                                        <>
                                            {!isScaned?
                                                <Col xl="12" hidden={isScaned || qrScanError !== ""}>
                                                    <QrScannerComponent setQr={setQrCode} setErr={setQrScanError} />
                                                </Col>
                                                :null
                                            }
                                            <Col xl="12" className="text-center mt-5" hidden={errors.anlagen === undefined}>
                                                <MdError className="text-danger" size={40} />
                                                <p className="text-danger">{errors.anlagen}</p>
                                            </Col>
                                            <Col xl="12" className="mt-3" hidden={!isScaned && data === undefined}>
                                                <div style={errors.anlagen? {border: "1px solid red"}: null}>
                                                    <p className="text-center">Klicken Sie auf die Anlagenkarten, um Ihre Anlagen hinzuzufügen/zu entfernen</p>
                                                    {qrData? 
                                                        qrData.anlagen.map(a => (
                                                        <Col key={`qrColAnlage-${a.id}`} xl="6" className="mt-5">
                                                            <SelectAnlageCard 
                                                                key={`qranlage-${a.id}`}
                                                                anlage={a} 
                                                                inSelected={data.anlagen.some(anlage => anlage.id === a.id)} 
                                                                selectHandler={qrSelectAnlageHandler}
                                                            />
                                                        </Col>
                                                        ))
                                                    :null}
                                                </div>
                                            </Col>
                                        </> :
                                    
                                    stage.address.inView ?
                                        <>
                                            <p className="text-energo">Anlagenadresse {data.qr_code !== ""? "Daten automatisch aus QR-Code ausgefühlt": ""}</p>
                                            <Row>
                                                <Col xl="4">
                                                    <FloatingLabel label="Anlagenverwendung">
                                                        <Form.Select
                                                            onChange={e => {setData(prev => ({...prev, anlagenUse: e.target.value})); setErrors({})}}
                                                            isValid={data.anlagenUse !== ""}
                                                            isInvalid={errors.anlageUseDesc}
                                                        >
                                                            <option value="Wohnung">Wohnung</option>
                                                            <option value="Gewerbe">Gewerbe</option>
                                                            <option value="Andere">Andere</option>
                                                        </Form.Select>
                                                    </FloatingLabel>
                                                </Col>
                                                <Col xl="8" hidden={data.anlagenUse !== "Andere"}>
                                                    <FloatingLabel label="Spezifische Anlagenverwendung">
                                                        <FormControl 
                                                            value={data.anlagenUseDesc}
                                                            onChange={e => {setData(prev => ({...prev, anlagenUseDesc: e.target.value})); setErrors({})} }
                                                            placeholder="Spezifische Anlagenverwendung" 
                                                            isValid={data.anlagenUseDesc !== ""}
                                                            isInvalid={errors.anlagenUseDesc}
                                                        />
                                                    </FloatingLabel>
                                                </Col>
                                            </Row>
                                            <Row className="mt-3">
                                                <Col xl="6">
                                                    <FloatingLabel label="Straße">
                                                        <FormControl
                                                            value={data.address}
                                                            onChange={e => {setData(prev => ({...prev, street: e.target.value})); setErrors({})}}
                                                            placeholder="Straße"
                                                            isValid={data.street !== "" && data.street.length > 3}
                                                            isInvalid={errors.street}
                                                        />
                                                    </FloatingLabel>
                                                </Col>
                                                <Col xl="2">
                                                    <FloatingLabel label="Hausnummer">
                                                        <FormControl 
                                                            value={data.houseNr}
                                                            onChange={e => {setData(prev => ({...prev, houseNr: e.target.value})); setErrors({})}}
                                                            placeholder="Hausnummer" 
                                                            isValid={data.houseNr !== ""}
                                                            isInvalid={errors.houseNr}
                                                        />
                                                    </FloatingLabel>
                                                </Col>
                                                <Col xl="2">
                                                    <FloatingLabel label="Stiege">
                                                        <FormControl 
                                                            value={data.stiege}
                                                            onChange={e => {setData(prev => ({...prev, stiege: e.target.value})); setErrors({})}}
                                                            isValid={data.stiege !== ""}
                                                            placeholder="Stiege" 
                                                            isInvalid={errors.stage}
                                                        />
                                                    </FloatingLabel>
                                                </Col>
                                                <Col xl="2">
                                                    <FloatingLabel label="Top">
                                                        <FormControl 
                                                            value={data.top}
                                                            onChange={e => {setData(prev => ({...prev, top: e.target.value})); setErrors({})}}
                                                            placeholder="Top" 
                                                        />
                                                    </FloatingLabel>
                                                </Col>
                                            </Row>
                                            <Row className="mt-3">
                                                <Col xl="4">
                                                    <FloatingLabel label="PLZ">
                                                        <FormControl 
                                                            value={data.zip}
                                                            onChange={e => {setData(prev => ({...prev, zip: e.target.value})); setErrors({})}}
                                                            placeholder="PLZ" 
                                                            isValid={data.zip !== ""}
                                                            isInvalid={errors.zip}
                                                        />
                                                    </FloatingLabel>
                                                </Col>
                                                <Col xl="8">
                                                    <FloatingLabel label="Ort">
                                                        <FormControl 
                                                            value={data.city}
                                                            onChange={e => {setData(prev => ({...prev, city: e.target.value})); setErrors({})}}
                                                            placeholder="Ort" 
                                                            isValid={data.city !== ""}
                                                            isInvalid={errors.city}
                                                        />
                                                    </FloatingLabel>
                                                </Col>
                                            </Row>
                                        </>:
                                    
                                    stage.anlageData.inView?
                                        <>
                                            <p className="text-energo">Anlagendaten</p>
                                            <AnlageDataStage data={data} setData={setData} errors={errors} setErrors={setErrors} />
                                        </> :

                                    stage.registerData.inView?
                                        <>
                                            <p className="text-energo">Anmeldedaten</p>
                                            {data.anlagen.length == 0?
                                                <>
                                                <Row className="mt-3">
                                                    <Col xl="4">
                                                        <FloatingLabel label="Anlage anmelden am">
                                                            <FormControl
                                                                value={data.registerDate}
                                                                onChange={e => {setData(prev => ({...prev, registerDate: e.target.value})); setErrors({})}}
                                                                type="date"
                                                                placeholder="Anlage anmelden am"
                                                                isValid={VALIDATOR.dateValid(data.registerDate)}
                                                                isInvalid={errors.registerDate}
                                                            />
                                                        </FloatingLabel>
                                                    </Col>
                                                    <Col xl="8">
                                                        <p hidden={data.registerDate === "" || UTILS.compareDate(new Date(data.registerDate), ">", new Date())}>
                                                            Das Anmeldedatum liegt in der Vergangenheit. Die Anmeldung 
                                                            wird in Abstimmung mit dem Energielieferanten am frühest 
                                                            möglichen Zeitpunkt durchgeführt.
                                                        </p>
                                                    </Col>
                                                </Row>
                                                <Row className="mt-3">
                                                    <Col xl="6" hidden={data.smartmeter}>
                                                        <FloatingLabel label="Zählerstand">
                                                            <FormControl
                                                                value={data.zaehlerstand1}
                                                                onChange={e => {setData(prev => ({...prev, zaehlerstand1: e.target.value})); setErrors({})}}
                                                                placeholder="Zählerstand"
                                                                isValid={data.zaehlerstand1 !== "" && VALIDATOR.IsZaehlerstand(data.zaehlerstand1)}
                                                                isInvalid={errors.zaehlerstand1}
                                                            />
                                                        </FloatingLabel>
                                                    </Col>
                                                    <Col xl="6" hidden={data.smartmeter || !data.secondZaehler}>
                                                        <FloatingLabel label="Zweiter Zählerstand">
                                                            <FormControl
                                                                value={data.zaehlerstand2}
                                                                onChange={e => {setData(prev => ({...prev, zaehlerstand2: e.target.value})); setErrors({})}}
                                                                placeholder="Zweiter Zählerstand"
                                                                isValid={VALIDATOR.IsZaehlerstand(data.zaehlerstand2)}
                                                                isInvalid={errors.zaehlerstand2}
                                                            />
                                                        </FloatingLabel>
                                                    </Col>
                                                </Row>
                                                </>
                                            :
                                            <>
                                                {data.anlagen.map((anlage, i) => (
                                                    <Row className="mb-3">
                                                       <Col xl="12">
                                                            <RegisterAnlageSmallCard 
                                                                key={`registerCardAnlage-${anlage.id}`} 
                                                                anlage={anlage} 
                                                                errors={errors}
                                                                setErrors={setErrors}
                                                                data={data}
                                                                setData={setData}
                                                            />
                                                       </Col>
                                                    </Row>
                                                ))}
                                            </>
                                            }
                                        </>:

                                    stage.summary.inView?
                                        <Row>
                                            <Col xl="6">
                                                <p className="text-energo"><FaLocationDot /> Adresse</p>
                                                <p hidden={data.anlagen !== undefined}>Anlagenverwendung: &nbsp; <small className="text-muted">{data.anlagenUse}</small></p>
                                                {data.anlagenUse === "Andere" && data.anlagen !== undefined?
                                                    <p>Speziefisch: &nbsp; <small className="text-muted">{data.anlagenUseDesc}</small></p>
                                                :null}
                                                <p>Straße: &nbsp; <small className="text-muted">{data.choice === "QR"? data.anlagen[0].x_studio_field_mNWrb : data.street}</small></p>
                                                <p>Hausnummer: &nbsp; <small className="text-muted">{data.choice === "QR"? data.anlagen[0].x_studio_field_uGpho : data.houseNr}</small></p>
                                                <p>Stiege: &nbsp; <small className="text-muted">{data.choice === "QR" && data.anlagen[0].x_studio_field_SG6Ld !== "False"? data.anlagen[0].x_studio_field_SG6Ld : data.stiege !== ""? data.stiege : "keine"}</small></p>
                                                <p>Top: &nbsp; <small className="text-muted">{data.choice === "QR"? data.anlagen[0].x_studio_field_6T9W2 : data.top}</small></p>
                                                <p>PLZ: &nbsp; <small className="text-muted">{data.choice === "QR"? data.anlagen[0].x_studio_field_EIo6y : data.zip}</small></p>
                                                <p>Ort: &nbsp; <small className="text-muted">{data.choice === "QR"? data.anlagen[0].x_studio_field_dxnOV : data.city}</small></p>
                                            </Col>
                                            <Col xl="6" hidden={data.choice === "QR"}>
                                                <p className="text-energo"><BsDeviceSsdFill /> Anlagedaten</p>
                                                <p>Energieform: &nbsp; <small className="text-muted">{data.energyForm}</small></p>
                                                <p>Smartmeter: &nbsp; {data.smartmeter? <FaCheck className="text-energo" /> : <FaXmark className="text-danger" />}</p>
                                                <p>Zählernummer: &nbsp; <small className="text-muted">{data.zaehlerNumber1}</small></p>
                                                <p>Zählerstand: &nbsp; <small className="text-muted">{data.zaehlerstand1}</small></p>
                                                <p>Zweite Zähler: &nbsp; {data.secondZaehler? <FaCheck className="text-energo" /> : <FaXmark className="text-danger" />}</p>
                                                {data.secondZaehler?
                                                    <>
                                                        <p>Zählernummer 2: &nbsp; <small className="text-muted">{data.zaehlerNumber1}</small></p>
                                                        <p>Zählerstand 2: &nbsp; <small className="text-muted">{data.zaehlerstand1}</small></p>
                                                    </>
                                                :null}
                                                <p>Bei Energielieferant anmelden: &nbsp; {data.register? <FaCheck className="text-energo" /> : <FaXmark className="text-danger" />}</p>
                                                {data.register?
                                                    <p>Anmelden am: &nbsp; <small className="text-muted">{new Date(data.registerDate).toLocaleDateString('DE-de')}</small></p>
                                                :null}
                                            </Col>
                                            <Col xl="6" hidden={data.choice !== "QR"}>
                                                <p className="text-energo"><span className="text-energo"><BsDeviceSsdFill /> Ausgewählte Anlagen</span></p>
                                                {data.anlagen.map((a, i) => (
                                                    <p key={`anlageList-${a.id}`}>{i + 1}. ENERGO Anlagennummer: &nbsp; <small className="text-muted">{a.x_studio_field_mWMGR}</small></p>
                                                ))}
                                            </Col>
                                        </Row> :

                                    stage.done.inView?
                                        <Row className="justify-content-center">
                                            <Col xl="10">
                                                <div className="animate__animated animate__backInRight">
                                                    <TbConfetti size={80} className="text-energo animate__animated animate__tada animate__delay-2s" />
                                                </div>
                                            </Col>
                                            <Col xl="10">
                                                <h3 className="mt-3">Fertig!</h3>
                                                <p className="text-muted">Vielen Dank! Wir haben die Daten zur Anlage erhalten und werden Sie in Kürze bearbeiten.</p>
                                            </Col>
                                            <Col xl="10" className="mt-3">
                                                <a href="/dashboard/anlagen/" className="link-energo" style={{marginRight: 20}}>Zum Anlagenverwaltung</a>
                                                <a href="neu/" onClick={e => resetAll(e)} className="link-energo">Neue Anlage hinzufügen</a>
                                            </Col>
                                        </Row>

                                :null}
                            </Row>
                            <Row className="mt-5 text-end">
                                <Col>
                                    <Button 
                                        onClick={() => backBtnHandler()}
                                        hidden={stage.choice.inView || stage.done.inView} 
                                        variant="warning" 
                                        style={{marginRight: 10}}>Zurück</Button>
                                    <Button 
                                        onClick={() => stage.summary.inView? send_data() : nextBtnHandler()}
                                        hidden={stage.done.inView} 
                                        className="btn-energo">{stage.summary.inView? "Absenden":"Weiter"}</Button>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    )
}
export default AnmeldenPage;